/* Frost — sitewide reveal-on-scroll. Every top-level section on a Frost
   page rises 28px and fades in via IntersectionObserver as it enters view;
   its direct content children stagger in behind it, capped at 480ms of
   added delay. It replays every time: once a section has fully left the
   screen it's reset (never visibly), so scrolling back plays it again.
   See assets/frost-reveal.css for the actual hidden/visible states this
   toggles.

   Sections already on screen when this runs (the hero and whatever sits
   under it) are left alone: hiding them only to fade them back in made the
   hero blink and pushed back LCP — same as Orizza, whose hero never fades. */
(function () {
  var THRESHOLD = 0.1;
  var CHILD_STEP_MS = 60;
  var CHILD_MAX_DELAY_MS = 480;

  function revealSection(section) {
    var children = section.querySelectorAll(':scope > * > *');
    children.forEach(function (child, index) {
      var delay = Math.min(index * CHILD_STEP_MS, CHILD_MAX_DELAY_MS);
      child.style.transitionDelay = delay + 'ms';
    });
    section.classList.add('frost-reveal-visible');
  }

  function resetSection(section) {
    section.classList.remove('frost-reveal-visible');
  }

  function init() {
    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    if (!sections.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      return;
    }

    // No fade-in on collection pages on mobile (same rule as
    // assets/reveal-stagger.js): the page shows straight away.
    // /collections/x/products/y is a product page and keeps the reveal.
    var path = window.location.pathname;
    if (
      window.matchMedia('(max-width: 989px)').matches &&
      /\/collections\//.test(path) &&
      !/\/products\//.test(path)
    ) return;

    var showObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= THRESHOLD) revealSection(entry.target);
        });
      },
      { threshold: THRESHOLD }
    );

    // Reset only once the section is completely off screen.
    var resetObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) resetSection(entry.target);
      });
    });

    // Which sections start on screen comes from this observer's first report
    // (computed off the critical path) rather than reading every section's
    // position up front, which forced a full layout during load. Those stay
    // as painted; the rest are hidden while still off screen, then revealed.
    var firstLook = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var section = entry.target;
        firstLook.unobserve(section);
        if (entry.isIntersecting) return;
        section.classList.add('frost-reveal');
        showObserver.observe(section);
        resetObserver.observe(section);
      });
    });

    sections.forEach(function (section) {
      // Opt-out: sections holding position: fixed overlays (sticky add to
      // cart, drawers, lightboxes) mark themselves with data-frost-reveal-skip.
      // The reveal's transform would otherwise pin those overlays to the
      // section instead of the screen.
      if (section.querySelector('[data-frost-reveal-skip]')) return;
      // The hero never fades — it's the page's main image (LCP).
      if (section.querySelector('.frost-hero')) return;
      firstLook.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
